var option_webview_default = {
  "option": "_44Mvt",
  "user_choice": "IXs6v",
  "check": "KBi-w",
  "image": "CqktM",
  "input": "Ub19R",
  "title": "wSRY1",
  "centered": "MaLA-",
  "with_result": "e5EwQ",
  "list": "izD5S",
  "with_image": "rUDEA",
  "progress": "AqTJT",
  "progress_value": "WwG9l",
  "label": "_4qbTl",
  "cta": "U0zHk",
  "adornment_icon": "_5En1J",
  "remove": "tW7h8",
  "removeButton": "pgRWK",
  "removeButtonIcon": "yox-N",
  "overlay": "_0hK8X",
  "shown": "bL-Fm",
  "dark": "xmpd9",
  "spinner": "Xz-Hh",
  "spin": "Vvz8f",
  "grid": "_1HV4-"
};
export {
  option_webview_default as default
};
//# sourceMappingURL=option-webview-scss.js.map
